// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n[data-v-b14d9efe] .el-dialog__body {\n  padding: 10px 10px;\n  min-height: 350px;\n  overflow: auto;\n  max-height: 60vh;\n}\n\n/* 如果是 Vue2 + Element UI，使用 ::v-deep */\n[data-v-b14d9efe] .no-wrap-column .cell {\n  white-space: nowrap;\n}\n\n/* 如果是 Vue3 + Element Plus，使用 :deep() */\n[data-v-b14d9efe] .no-wrap-column .cell {\n  white-space: nowrap;\n}\n.el-form-item--mini.el-form-item[data-v-b14d9efe] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
